import React from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent';

const TermsOfSale = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy"><ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage} /></div>
            <div className="container mt-2 mb-5 py-4 privacy-policy">
                <h3 className='fw-bold'>CURRY KING (PRIVATE) LIMITED</h3>
                <h3 className='fw-bold'>Terms of Sale</h3>
                <p> Version 1.3 | Effective Date: 1st May 2025</p>
                <p>
                    These Terms of Sale ("Terms") govern the purchase and consumption of food products ("Products") sold and distributed by Curry King (Private) Limited, a company duly incorporated under the laws of Sri Lanka, having its registered office at No. 55/2, Vauxhall Lane, Colombo 2 ("Curry King", "we", "us", or "our"). By purchasing our Products, you ("Customer", "you", or "your") agree to be bound by the following Terms:
                </p>
                <hr />
                <h5 className='fw-bold'>1. Product Description and Variability</h5>
                <p>
                    Curry King strives to present accurate and up-to-date product descriptions and images. However, due to the nature of food preparation and fresh sourcing:
                </p>
                <ul>
                    <li>
                        The composition of Products, particularly vegetables and accompaniments, may <strong>differ from the product image or prior descriptions</strong>, depending on seasonal availability and supplier substitutions.
                    </li>
                    <li>
                        <strong>Images displayed on packaging, promotional material, or ordering platforms are for illustrative purposes only</strong> and may not reflect the exact presentation, arrangement, or packaging of the delivered Product.
                    </li>
                    <li>
                        Variations in visual presentation do not entitle the Customer to any claim for replacement, refund, or compensation.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>2. Spices and Taste Variation</h5>
                <p>
                    Curry King sources spices and ingredients from reputable growers and certified suppliers. Every effort is made to ensure consistency and adherence to quality expectations. Nevertheless:
                </p>
                <ul>
                    <li>
                        <strong>Flavour, color, and aroma of spices may vary</strong> due to natural factors including soil, climate, and seasonal changes.
                    </li>
                    <li>
                        Such variations are inherent in naturally grown ingredients and shall <strong>not constitute grounds for liability</strong> or dissatisfaction claims.
                    </li>
                    <li>
                        Curry King disclaims all warranties, express or implied, regarding flavour consistency across batches where natural ingredient variation is involved.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>3. Limitation of Liability</h5>
                <p>
                    To the fullest extent permissible by applicable law, the <strong>maximum liability</strong> of Curry King for any claim, loss, or damage arising from the purchase or consumption of a Product shall be <strong>strictly limited to the purchase price paid</strong> by the Customer for the specific Product in question.
                </p>
                <p>
                    Curry King shall <strong>not be liable</strong> for any indirect, incidental, consequential, special, or punitive damages, including but not limited to emotional distress, loss of enjoyment, or health-related claims unrelated to proven manufacturing fault.
                </p>
                <hr />
                <h5 className='fw-bold'>4. Refund and Replacement Policy</h5>
                <p>
                    All sales are deemed <strong>final and non-refundable</strong>,  in accordance with food safety best practices and regulatory standards.
                </p>
                <ul>
                    <li>Refunds, returns, or replacements will <strong>not be issued</strong> once a Product has been sold, collected, or delivered.
                    </li>
                    <li>
                        In
                        <strong>exceptional cases</strong>, where a legitimate complaint is raised within a reasonable time and deemed <strong>fair and just</strong> by the management, a refund or replacement may be granted <strong>at the sole discretion of Curry King.</strong>
                    </li>
                    <li>
                        Claims must be supported by clear evidence and reported through official communication channels.
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>5. Food Safety, Freshness, and Consumption Period</h5>
                <p>
                    Curry King’s ready-to-eat Products are prepared daily with <strong>utmost attention to freshness</strong> and <strong>without the use of artificial preservatives.</strong>
                </p>
                <ul>
                    <li>Customers are <strong>strictly advised to consume the Products within two (2) hours</strong> from the time of sale to ensure product safety and optimal quality.
                    </li>
                    <li>
                        Consumption beyond this recommended window may result in quality degradation or food safety risks for which<strong>Curry King shall not be held liable.</strong>
                    </li>
                    <li>
                        Customers are also expected to follow all handling instructions and avoid exposing the Products to excessive heat, contamination, or delay in consumption.
                    </li>
                    <li>
                        The Company assumes no responsibility for spoilage, degradation, or health impact resulting from <strong>non-compliance with these guidelines.</strong>
                    </li>
                </ul>
                <hr />
                <h5 className='fw-bold'>6. Governing Law and Jurisdiction</h5>
                <p>
                    These Terms shall be governed by and construed in accordance with the laws of the <strong>Democratic Socialist Republic of Sri Lanka.</strong> Any dispute or claim arising in connection with these Terms shall fall under the <strong>exclusive jurisdiction of the courts of Colombo.</strong>
                </p>
                <hr />
                <h5 className='fw-bold'>7. Modifications and Updates</h5>
                <p>
                    Curry King reserves the right to <strong>modify, amend, or update</strong> these Terms at any time, without prior notice. Any changes shall become effective upon publication on our official website or communication through our digital ordering platforms. Continued purchase of Products after such publication shall constitute your acceptance of the updated Terms.
                </p>
                <hr />
                <h5 className='fw-bold'>8. Contact Information</h5>
                <p>
                    For any questions, complaints, or clarification regarding these Terms or our Products, please contact us at:
                </p>
                <strong>Curry King (Private) Limited</strong>
                <br />
                55/2 Vauxhall Lane,
                <br />
                Colombo 2, Sri Lanka
                <br />
                <strong>Email:</strong> regulatory@curryking.lk
                <br />
                <strong>Phone:</strong> +94 11 444 1300
                <hr />
            </div>
        </>
    )
}

export default TermsOfSale;